exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".txt-blue[_v-af1fd9a4]{color:#00e}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-af1fd9a4&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/orders/services.vue
// module id = 369
// module chunks = 0